import React, {useCallback} from 'react';
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import iconStop from "../../../images/modal-icon-stop2.svg";
import Lottie from "react-lottie";
import Lock from "../../../animation/unlock_key_anim.json";

const RoleTrialModal = ({afterClose}) => {

    const clickBuy = useCallback(() => {
        afterClose();
        setTimeout(() => document.getElementById('premium-order').scrollIntoView(), 500);
    }, [afterClose]);

    const lottieOptions = {
        loop: true,
        autoplay: true,
        animationData: Lock,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Modal isOpen={true} toggle={afterClose} fade={true} centered={true} size="lg" contentClassName="rounded-20">
            <ModalHeader tag="div" toggle={afterClose} className="align-items-start">
                <div className="d-flex align-content-center">
                    <Lottie options={lottieOptions} height={50} width={50} />
                    <h1 className="modal-title text-22 text-start my-auto ps-3">
                        <FormattedMessage defaultMessage="Aktivovat zkušební verzi"/><br/>
                        <FormattedMessage defaultMessage="Škola s{nbsp}nadhledem PREMIUM" values={{ nbsp: <React.Fragment>&nbsp;</React.Fragment> }}/>
                    </h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        <div className="ps-2">
                            <img src={iconStop} />
                        </div>
                        <p className="mt-3 text-19 ps-2">
                            <FormattedMessage defaultMessage="Bezplatnou zkušební verzi vám {cannot}, protože nemáte přiřazenou požadovanou roli."  values={{ cannot: <strong><FormattedMessage defaultMessage="nemůžeme aktivovat" /></strong> }} />
                        </p>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );

};

RoleTrialModal.propTypes = {
    afterClose: PropTypes.func.isRequired,
};

RoleTrialModal.defaultProps = {}

export default RoleTrialModal;
